<template>
  <main>
    <div>
      <v-container>
        <v-card class="">
          <div class="card-content">
            <img src="/static/svg/communication/user.svg" style="height: 40px;">
            <span class="card-title" style="vertical-align:top;">
              サークルメンバー
            </span>
            <table class="bordered">
              <thead>
              <tr>
                <th data-field="id">名前</th>
                <th data-field="name">役職</th>
              </tr>
              </thead>

              <tbody>
              <tr>
                <td>宮乃ぺこ</td>
                <td>代表</td>
              </tr>
              <tr>
                <td>明地えしら</td>
                <td></td>
              </tr>
              <tr>
                <td>ecolight</td>
                <td></td>
              </tr>
              <tr>
                <td>うりMk-2</td>
                <td></td>
              </tr>
              <tr>
                <td>ryuto</td>
                <td></td>
              </tr>
              <tr>
                <td>すず</td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </v-card>
      </v-container>
    </div>
  </main>
</template>

<script>
export default {
  name: 'members',
  head: {
    title: {
      inner: 'サークルメンバー'
    }
  }
}
</script>


// WEBPACK FOOTER //
// Members.vue?77a257a5